<div class="tab-pane show active fade details-view-results support-links" id="trial-links" role="tabpanel">
    <!-- Start: Support Links -->
    <div>
        <div class="title-culture-select">
            <h2>Support Links</h2>

            <app-button variant="primary" text="Add Link" (clicked)="formModal.add()" />
        </div>
    </div>

    <div class="support-links-list">
        @for (link of supportLinks; track link.id) {
            <div class="support-link-item">
                <div class="support-link-item-info">
                    <span class="support-link-item-label">
                        <a [href]="link.url" tareget="_blank"><i class="fas fa-link"></i></a>
                        {{ link.label }}
                    </span>

                    <ul>
                        @if (link.allCountries) {
                            <li>All Countries</li>
                        } @else {
                            @for (country of splitCountries(link.countries); track country) {
                                <li>{{ country }}</li>
                            }
                        }
                    </ul>
                </div>

                <div class="support-link-item-actions">
                    <app-button text="Remove" variant="info" size="sm" (click)="onRemove(link)" />
                    <app-button text="Edit" variant="secondary" size="sm" (clicked)="formModal.update(link)" />
                </div>
            </div>
        }

        @if (supportLinks.length === 0) {
            <div class="no-results inside">
                <div class="inner">
                    <div class="image">
                        <img src="assets/img/no-results-illustration.png" alt="No results found" />
                    </div>
                    <div class="content">
                        <h2>No Results Found</h2>
                        <p>There are no support links assigned to this trial.</p>
                    </div>
                </div>
            </div>
        }
    </div>
    <!-- End: Support Links -->
</div>

<app-confirm-action-modal #confirmModal title="Remove Support Link?" message="Are you sure you want to remove this support link?" (confirmed)="onRemoveConfirmed($event)"></app-confirm-action-modal>

<app-trial-support-link-form #formModal [trial]="trial" (updated)="supportLinks = $event" />
